/* Isolated PDP behavior. Reuses the existing Dawn cart and NORGIRA wishlist contracts. */
(() => {
  function renderShipping(element, total, currency) {
    const rate = currency === 'USD' ? 1 : Number(window.Shopify?.currency?.rate);
    if (!(rate > 0) || !Number.isFinite(total)) return;
    const remaining = Math.max(0, Math.round(10000 * rate) - total);
    const emphasis = document.createElement('strong');
    emphasis.textContent = 'FREE SHIPPING';
    if (remaining > 0) {
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', { minimumFractionDigits:2, maximumFractionDigits:2 }).format(remaining / 100);
      element.replaceChildren(document.createTextNode(`YOU’RE ${amount} ${currency} AWAY FROM `), emphasis);
    } else element.replaceChildren(emphasis, document.createTextNode(' UNLOCKED'));
  }
  function renderCartShipping(cart) {
    if (!Number.isFinite(cart?.total_price)) return;
    document.querySelectorAll('[data-nhp-shipping]').forEach(element => {
      element.dataset.total = cart.total_price;
      element.dataset.currency = cart.currency;
      renderShipping(element, cart.total_price, cart.currency);
    });
  }
  let cartRefresh = null, refreshAgain = false;
  function refreshCartShipping() {
    if (cartRefresh) { refreshAgain = true; return cartRefresh; }
    cartRefresh = fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers:{Accept:'application/json'}, cache:'no-store' })
      .then(response => { if (!response.ok) throw Error('Cart refresh failed'); return response.json(); })
      .then(renderCartShipping).catch(() => {})
      .finally(() => { cartRefresh = null; if (refreshAgain) { refreshAgain = false; refreshCartShipping(); } });
    return cartRefresh;
  }
  function bindCartShipping() {
    if (window.norgiraPdpShippingBound) return;
    window.norgiraPdpShippingBound = true;
    document.addEventListener('cart:updated', refreshCartShipping);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (Number.isFinite(event.cartData?.total_price)) renderCartShipping(event.cartData);
        else refreshCartShipping();
      });
    }
    window.addEventListener('pageshow', event => { if (event.persisted) refreshCartShipping(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindCartShipping, {once:true});
  else bindCartShipping();
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-nhp-variants]').textContent);
    const form = root.querySelector('.nhp__form');
    const idInput = form.querySelector('[data-nhp-variant]');
    const add = form.querySelector('[name="add"]');
    const addLabel = root.querySelector('[data-nhp-add-label]');
    const quantity = form.querySelector('[name="quantity"]');
    const status = root.querySelector('[data-nhp-status]');
    const inventory = root.querySelector('[data-nhp-inventory]');
    const shipping = root.querySelector('[data-nhp-shipping]');
    if (shipping) renderShipping(shipping, Number(shipping.dataset.total), shipping.dataset.currency || 'USD');
    const fields = [...root.querySelectorAll('[data-option-position]')];
    // This outfit uses three purchasing modes with independent component sizes.
    // Other products keep their existing picker behavior unchanged.
    const outfit = ['earphone-velour-hoodie-pants-pink', 'earphone-velour-hoodie-pants-blue'].includes(root.dataset.handle);
    const outfitSizes = { hoodie:'1', pants:'1' };
    function syncOutfitOptions() {
      if (!outfit) return;
      const fieldAt = position => fields.find(field => Number(field.dataset.optionPosition) === position);
      const purchase = fieldAt(1)?.querySelector('input:checked')?.value || 'Hoodie';
      [[2,'hoodie',purchase !== 'Pants'],[3,'pants',purchase !== 'Hoodie']].forEach(([position,part,included]) => {
        const field = fieldAt(position);
        if (!field) return;
        const checked = field.querySelector('input:checked');
        if (checked && checked.value !== 'Not included') outfitSizes[part] = checked.value;
        const value = included ? outfitSizes[part] : 'Not included';
        field.querySelectorAll('input').forEach(input => {
          input.checked = input.value === value;
          if (input.value === 'Not included') {
            input.hidden = true;
            input.tabIndex = -1;
            input.setAttribute('aria-hidden', 'true');
            input.nextElementSibling.style.display = 'none';
          }
        });
        field.hidden = !included;
        field.style.display = included ? '' : 'none';
      });
    }
    const gallery = root.querySelector('[data-nhp-gallery]');
    const media = [...gallery.querySelectorAll('[data-media-id]')];
    const pages = [...root.querySelectorAll('[data-nhp-page]')];
    let busy = false;
    let selected = variants.find(v => String(v.id) === idInput.value);
    idInput.disabled = false;
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = matchMedia('(min-width:990px)');
    let activeMedia = 0;
    function showMedia(index) {
      const item = media[index];
      if (!item) return;
      activeMedia = index;
      if (matchMedia('(max-width: 989px)').matches) {
        gallery.scrollTo({ left: item.offsetLeft - gallery.offsetLeft - (gallery.clientWidth - item.clientWidth) / 2, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      } else {
        item.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth', block: 'center' });
      }
    }
    pages.forEach((button, index) => {
      button.dataset.imageNumber = String(index + 1);
      button.addEventListener('click', () => showMedia(index));
    });
    gallery.addEventListener('keydown', event => {
      if (!desktop.matches || event.target !== gallery) return;
      const delta = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[event.key];
      if (!delta) return;
      event.preventDefault();
      showMedia(Math.max(0, Math.min(media.length - 1, activeMedia + delta)));
    });
    let scheduled = false;
    const scheduleGalleryState = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        const center = desktop.matches ? (innerHeight + (Number.parseFloat(getComputedStyle(root).getPropertyValue('--nhp-top')) || 140)) / 2 : gallery.getBoundingClientRect().left + gallery.clientWidth / 2;
        let active = 0, closest = Infinity;
        media.forEach((item, index) => { const rect = item.getBoundingClientRect(); const distance = Math.abs((desktop.matches ? rect.top + rect.height / 2 : rect.left + rect.width / 2) - center); if (distance < closest) { closest = distance; active = index; } });
        activeMedia = active;
        pages.forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
      });
    };
    gallery.addEventListener('scroll', scheduleGalleryState, { passive: true });
    window.addEventListener('scroll', () => { if (desktop.matches) scheduleGalleryState(); }, { passive: true });
    function updateVariant(updateUrl = true) {
      syncOutfitOptions();
      const options = fields.sort((a,b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map(field => field.querySelector('input[type="radio"]:checked')?.value);
      selected = variants.find(v => v.options.every((value, index) => value === options[index]));
      if (!fields.length) selected = variants[0];
      idInput.value = selected?.id || '';
      idInput.disabled = !selected;
      add.disabled = busy || !selected?.available;
      addLabel.textContent = selected ? (selected.available ? 'ADD TO CART' : 'SOLD OUT') : 'UNAVAILABLE';
      if (inventory) {
        const stock = Number(selected?.inventoryQuantity);
        inventory.hidden = !(selected?.available && selected.inventoryTracked && Number.isInteger(stock) && stock > 0 && stock < 10);
        inventory.querySelector('[data-nhp-inventory-label]').textContent = inventory.hidden ? '' : `ONLY ${stock} LEFT`;
      }
      if (selected) {
        root.querySelector('[data-nhp-price]').textContent = selected.price;
        quantity.min = selected.quantityMin;
        quantity.step = selected.quantityStep;
        if (selected.quantityMax) quantity.max = selected.quantityMax; else quantity.removeAttribute('max');
        clampQuantity();
        if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', selected.id); history.replaceState({}, '', url); }
      }
      fields.forEach((field, position) => {
        const legend = field.querySelector('legend');
        if (legend && field.classList.contains('nhp__option--color')) legend.dataset.selectedValue = options[position] || '';
        field.querySelectorAll('input').forEach(input => {
          const candidate = [...options]; candidate[position] = input.value;
          const available = outfit
            ? variants.some(v => v.options[position] === input.value)
            : variants.some(v => v.available && v.options.every((value,index) => value === candidate[index]));
          input.nextElementSibling.classList.toggle('is-unavailable', !available);
        });
        const sizeSelect = field.querySelector('.nhp__desktop-size');
        if (sizeSelect) {
          sizeSelect.value = options[position] || '';
          [...sizeSelect.options].forEach(option => {
            const candidate = [...options]; candidate[position] = option.value;
            const available = variants.some(v => v.available && v.options.every((value, index) => value === candidate[index]));
            option.disabled = !available;
            option.textContent = `${option.value}${available ? '' : ' — SOLD OUT'}`;
          });
          sizeSelect.dispatchEvent(new Event('nhp:size-sync'));
        }
      });
      status.textContent = '';
    }
    function clampQuantity() {
      const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      quantity.value = Math.max(min, Math.min(max, min + Math.round(((Number(quantity.value) || min) - min) / step) * step));
      root.querySelector('[data-nhp-quantity="-1"]').disabled = Number(quantity.value) <= min;
      root.querySelector('[data-nhp-quantity="1"]').disabled = Number(quantity.value) >= max;
    }
    fields.forEach(field => field.addEventListener('change', () => {
      updateVariant();
      if (selected?.mediaId) { const index = media.findIndex(item => item.dataset.mediaId === String(selected.mediaId)); if (index >= 0 && matchMedia('(max-width: 989px)').matches) showMedia(index); }
    }));
    root.querySelectorAll('[data-nhp-quantity]').forEach(button => button.addEventListener('click', () => { quantity.value = (Number(quantity.value) || 1) + Number(button.dataset.nhpQuantity) * (Number(quantity.step) || 1); clampQuantity(); }));
    quantity.addEventListener('change', clampQuantity);
    fields.filter(field => field.classList.contains('nhp__option--size')).forEach(field => {
      const select = field.querySelector('.nhp__desktop-size') || document.createElement('select');
      select.className = 'nhp__desktop-size';
      select.setAttribute('aria-label', 'Choose size');
      if (!select.options.length) field.querySelectorAll('input[type="radio"]').forEach(input => {
        const option = document.createElement('option');
        option.value = input.value; option.textContent = input.value;
        select.append(option);
      });
      select.addEventListener('change', event => {
        event.stopPropagation();
        if (!desktop.matches) return;
        const radio = [...field.querySelectorAll('input[type="radio"]')].find(input => input.value === select.value);
        if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      field.append(select);
      // PC-only presentation; the original radios remain the Shopify variant authority.
      const picker = document.createElement('div');
      picker.className = 'nhp__size-picker';
      const trigger = document.createElement('button');
      trigger.type = 'button'; trigger.className = 'nhp__size-trigger';
      trigger.setAttribute('role', 'combobox');
      trigger.setAttribute('aria-label', 'Choose size');
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      const value = document.createElement('span');
      const arrow = document.createElement('span');
      arrow.className = 'nhp__size-arrow'; arrow.setAttribute('aria-hidden', 'true');
      trigger.append(value, arrow);
      const menu = document.createElement('div');
      menu.className = 'nhp__size-menu'; menu.id = `${root.id}-sizes-${field.dataset.optionPosition}`;
      menu.setAttribute('role', 'listbox'); menu.setAttribute('aria-label', 'Size'); menu.hidden = true;
      trigger.setAttribute('aria-controls', menu.id);
      const choices = [...select.options].map((option, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'nhp__size-choice'; button.tabIndex = -1;
        button.id = `${menu.id}-${index}`; button.setAttribute('role', 'option');
        button.addEventListener('click', () => choose(index));
        menu.append(button); return button;
      });
      let active = -1;
      const close = () => {
        menu.hidden = true; trigger.setAttribute('aria-expanded', 'false');
        trigger.removeAttribute('aria-activedescendant');
      };
      const focusChoice = index => {
        active = index;
        choices.forEach((button, i) => button.classList.toggle('is-active', i === index));
        if (index >= 0) {
          trigger.setAttribute('aria-activedescendant', choices[index].id);
          const option = choices[index];
          if (option.offsetTop < menu.scrollTop) menu.scrollTop = option.offsetTop;
          else if (option.offsetTop + option.offsetHeight > menu.scrollTop + menu.clientHeight) menu.scrollTop = option.offsetTop + option.offsetHeight - menu.clientHeight;
        }
      };
      const sync = () => {
        value.textContent = select.selectedOptions[0]?.textContent || 'Select size';
        choices.forEach((button, i) => {
          button.textContent = select.options[i].textContent;
          button.disabled = select.options[i].disabled;
          button.setAttribute('aria-selected', String(select.options[i].value === select.value));
        });
      };
      const open = () => {
        if (!desktop.matches) return;
        sync(); menu.hidden = false; trigger.setAttribute('aria-expanded', 'true');
        const index = choices.findIndex((button, i) => !button.disabled && select.options[i].value === select.value);
        focusChoice(index >= 0 ? index : choices.findIndex(button => !button.disabled));
      };
      function choose(index) {
        if (!desktop.matches || choices[index]?.disabled || !choices[index]) return;
        select.value = select.options[index].value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        close(); trigger.focus({ preventScroll: true });
      }
      trigger.addEventListener('click', () => menu.hidden ? open() : close());
      trigger.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); return; }
        if (event.key === 'Tab') { close(); return; }
        if (['Enter', ' '].includes(event.key)) {
          event.preventDefault(); if (menu.hidden) open(); else choose(active); return;
        }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (menu.hidden) { open(); return; }
        const enabled = choices.map((button, i) => button.disabled ? -1 : i).filter(i => i >= 0);
        const current = enabled.indexOf(active);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? enabled.length - 1 : Math.max(0, Math.min(enabled.length - 1, current + (event.key === 'ArrowDown' ? 1 : -1)));
        focusChoice(enabled[next] ?? -1);
      });
      select.addEventListener('nhp:size-sync', sync);
      picker.addEventListener('focusout', event => { if (event.relatedTarget && !picker.contains(event.relatedTarget)) close(); });
      document.addEventListener('pointerdown', event => { if (!picker.contains(event.target)) close(); });
      desktop.addEventListener('change', close);
      picker.append(trigger, menu); field.append(picker);
      select.classList.add('nhp__desktop-size--enhanced');
    });
    updateVariant(false);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !selected?.available) return;
      clampQuantity();
      busy = true; add.disabled = true; add.setAttribute('aria-busy', 'true'); addLabel.textContent = 'ADDING…'; status.textContent = '';
      const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      try {
        const body = new FormData(form);
        if (drawer?.getSectionsToRender) { body.set('sections', drawer.getSectionsToRender().map(section => section.id).join(',')); body.set('sections_url', location.pathname); drawer.setActiveElement?.(add); }
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add this item. Please try again.');
        status.textContent = 'Added to cart.';
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'norgira-pdp', productVariantId: selected.id, cartData: data });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
        if (drawer?.renderContents && data.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
        else location.assign(window.routes?.cart_url || '/cart');
      } catch (error) { status.textContent = error.message || 'Unable to add this item. Please try again.'; }
      finally { busy = false; add.disabled = !selected?.available; add.removeAttribute('aria-busy'); addLabel.textContent = selected?.available ? 'ADD TO CART' : 'SOLD OUT'; }
    });
    const wishlist = root.querySelector('[data-nhp-wishlist]');
    const wishlistKey = 'norgira:wishlist:v1';
    function readWishlist() { try { const values = JSON.parse(localStorage.getItem(wishlistKey) || '[]'); return Array.isArray(values) ? values.filter(value => typeof value === 'string') : []; } catch (_) { return []; } }
    function syncWishlist() { const active = readWishlist().includes(root.dataset.handle); wishlist.setAttribute('aria-pressed', String(active)); wishlist.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist'); }
    wishlist.addEventListener('click', () => { try { const values = readWishlist(); const handle = root.dataset.handle; const next = values.includes(handle) ? values.filter(value => value !== handle) : [...new Set([...values, handle])]; localStorage.setItem(wishlistKey, JSON.stringify(next)); window.dispatchEvent(new CustomEvent('norgira:wishlist-change', { detail: { handles: next } })); } catch (_) { status.textContent = 'Your browser could not save this item.'; } syncWishlist(); });
    window.addEventListener('norgira:wishlist-change', syncWishlist);
    window.addEventListener('storage', event => { if (event.key === wishlistKey) syncWishlist(); });
    syncWishlist();
    const dialog = root.querySelector('[data-nhp-dialog]');
    const zoomImage = root.querySelector('[data-nhp-zoom-image]');
    let previousFocus;
    const zoomButtons = [...root.querySelectorAll('[data-nhp-zoom]')];
    let zoomIndex = 0;
    const zoomNav = document.createElement('div');
    zoomNav.className = 'nhp__desktop-zoom-nav';
    const zoomPrevious = document.createElement('button'), zoomNext = document.createElement('button'), zoomCount = document.createElement('span');
    zoomPrevious.type = zoomNext.type = 'button';
    zoomPrevious.textContent = '←'; zoomNext.textContent = '→';
    zoomPrevious.setAttribute('aria-label', 'Previous enlarged image'); zoomNext.setAttribute('aria-label', 'Next enlarged image');
    zoomCount.setAttribute('aria-live', 'polite');
    zoomNav.append(zoomPrevious, zoomCount, zoomNext); dialog.append(zoomNav);
    const showZoom = index => {
      const button = zoomButtons[index];
      if (!button) return;
      zoomIndex = index;
      zoomImage.src = button.dataset.fullSrc;
      zoomImage.alt = button.querySelector('img').alt || 'Product image';
      zoomCount.textContent = `${index + 1} / ${zoomButtons.length}`;
      zoomPrevious.disabled = index === 0; zoomNext.disabled = index === zoomButtons.length - 1;
    };
    zoomButtons.forEach((button, index) => button.addEventListener('click', () => { previousFocus = button; showZoom(index); dialog.showModal(); }));
    zoomPrevious.addEventListener('click', () => showZoom(zoomIndex - 1)); zoomNext.addEventListener('click', () => showZoom(zoomIndex + 1));
    dialog.addEventListener('keydown', event => {
      if (!desktop.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); showZoom(zoomIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    root.querySelector('[data-nhp-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => previousFocus?.focus({ preventScroll: true }));
    const more = root.querySelector('[data-nhp-more]');
    more.addEventListener('click', () => { const expanded = more.getAttribute('aria-expanded') !== 'true'; more.setAttribute('aria-expanded', String(expanded)); more.textContent = expanded ? 'VIEW LESS' : 'VIEW MORE'; root.querySelector('.nhp__information').classList.toggle('is-expanded', expanded); });
    const heading = root.querySelector('.nhp__heading');
    const layout = root.querySelector('.nhp__layout');
    const galleryBlock = root.querySelector('.nhp__gallery');
    const priceRow = root.querySelector('.nhp__price-row');
    const title = root.querySelector('.nhp__title');
    const information = root.querySelector('.nhp__information');
    const infoContent = root.querySelector('[data-nhp-info-content]');
    const infoDetails = information.querySelector('details');
    const pagination = root.querySelector('.nhp__pagination');
    const sizeGroup = root.querySelector('.nhp__size-group');
    const sizeField = root.querySelector('.nhp__option--size');
    // Collapsed PC previews keep whole content blocks, never a pixel-height text crop.
    const groups = [...infoContent.children].filter(element => element.textContent.trim() || element.querySelector('img,table'));
    groups.slice(1).forEach(element => element.classList.add('nhp__preview-rest'));
    const firstDescription = groups[0]?.querySelector('.nhp__description') || groups[0];
    let seenBody = false;
    [...(firstDescription?.children || [])].forEach(element => {
      if (seenBody) element.classList.add('nhp__preview-rest');
      else if (!/^H[1-6]$/.test(element.tagName) && element.textContent.trim()) seenBody = true;
    });
    const hasPreviewRest = !!infoContent.querySelector('.nhp__preview-rest');
    const detailsColumn = root.querySelector('.nhp__details') || document.createElement('div'), detailsInner = root.querySelector('.nhp__details-inner') || document.createElement('div'), purchaseInner = root.querySelector('.nhp__purchase-inner') || document.createElement('div');
    detailsColumn.className = 'nhp__details'; detailsInner.className = 'nhp__details-inner'; purchaseInner.className = 'nhp__purchase-inner';
    detailsColumn.append(detailsInner);
    const buy = root.querySelector('.nhp__buy');
    if (sizeGroup && sizeField) {
      const sizeGuide = document.createElement('button');
      sizeGuide.type = 'button'; sizeGuide.className = 'nhp__size-guide'; sizeGuide.textContent = 'Size guide';
      sizeGuide.setAttribute('aria-controls', infoContent.id);
      sizeField.append(sizeGuide);
      sizeGuide.addEventListener('click', () => {
        if (!desktop.matches) return;
        infoDetails.open = true;
        information.classList.add('is-expanded');
        more.setAttribute('aria-expanded', 'true'); more.textContent = 'VIEW LESS';
        sizeGroup.tabIndex = -1; sizeGroup.focus({ preventScroll: true });
        information.scrollTo({ top: sizeGroup.getBoundingClientRect().top - information.getBoundingClientRect().top + information.scrollTop - 8, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      });
    }
    information.querySelectorAll('details').forEach(details => details.addEventListener('toggle', () => {
      if (!desktop.matches || !details.open) return;
      information.querySelectorAll('details').forEach(other => { if (other !== details) other.open = false; });
      if (details === infoDetails) measureHeading();
    }));
    function measureHeading() {
      if (desktop.matches) {
        if (detailsColumn.parentElement !== layout) layout.prepend(detailsColumn);
        if (heading.parentElement !== detailsInner) detailsInner.append(heading);
        if (information.parentElement !== detailsInner) detailsInner.append(information);
        if (purchaseInner.parentElement !== buy) {
          [...buy.children].forEach(element => purchaseInner.append(element));
          buy.append(purchaseInner);
        }
        if (wishlist.parentElement !== priceRow) priceRow.append(wishlist);
        title.style.removeProperty('font-size');
        const headerHeight = document.querySelector('.norgira-header')?.getBoundingClientRect().height || 116;
        root.style.setProperty('--nhp-top', `${headerHeight + 16}px`);
        const height = heading.offsetHeight;
        root.style.setProperty('--nhp-heading-height', `${height}px`);
        more.hidden = !hasPreviewRest;
      } else {
        if (detailsColumn.parentElement === layout) {
          layout.prepend(heading); layout.append(information); detailsColumn.remove();
        }
        if (purchaseInner.parentElement === buy) {
          [...purchaseInner.children].forEach(element => buy.append(element)); purchaseInner.remove();
        }
        if (heading.previousElementSibling !== galleryBlock) galleryBlock.after(heading);
        if (wishlist.parentElement !== heading) heading.append(wishlist);
        title.style.removeProperty('font-size');
        root.style.removeProperty('--nhp-top');
        more.hidden = false;
        if (pagination && galleryBlock.lastElementChild !== pagination) galleryBlock.append(pagination);
      }
      scheduleGalleryState();
    }
    new ResizeObserver(measureHeading).observe(heading);
    desktop.addEventListener('change', measureHeading);
    window.addEventListener('resize', measureHeading, { passive: true });
    document.fonts.ready.then(measureHeading);
    measureHeading();
  }
  document.querySelectorAll('[data-nhp]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-nhp]').forEach(init));
})();
